export class StatusCompany {
    id: number | undefined
	name: string 

	constructor() {
		this.name = ""
	}
}
